import { Box, Input, Popover, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { DECK_IMG_URL } from "../../constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
interface SelectDeckProps {
  decks: any[];
  deck?: any;
  onChangeDeck: (value: any) => void;
}
const SelectDeck = ({ decks, deck, onChangeDeck }: SelectDeckProps) => {
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLDivElement) | null
  >(null);
  const [searchText, setSearchText] = useState("");

  const filterDecks = useMemo(() => {
    if (searchText.trim() === "") return decks;
    return decks.filter((deck) =>
      deck.title.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, decks]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          padding: "10px",
          backgroundColor: "#F7FAFC",
        }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {deck ? (
          <>
            <img
              src={DECK_IMG_URL.replace("DECK_ID", deck.id)}
              alt={deck.title}
              style={{ height: "40px" }}
            />
            <Typography
              sx={{
                marginLeft: "10px",
              }}
            >
              {deck.title}
            </Typography>
          </>
        ) : (
          <Typography>Select deck</Typography>
        )}
        <KeyboardArrowDownIcon
          sx={{
            marginLeft: "10px",
          }}
        />
      </Box>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            padding: "10px",
          }}
        >
          <Input
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            placeholder="Search ..."
            sx={{
              width: "100%",
              backgroundColor: "#F7FAFC",
              padding: "5px 10px",
              "&::before": {
                display: "none",
              },
              "&::after": {
                display: "none",
              },
            }}
          />
          <Box
            sx={{
              flex: 1,
              maxHeight: 300,
              minWidth: 240,
              overflowY: "auto",
            }}
          >
            {filterDecks.map((item) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={() => {
                    onChangeDeck(item);
                    setAnchorEl(null);
                  }}
                >
                  <img
                    src={DECK_IMG_URL.replace("DECK_ID", item.id)}
                    alt={item.title}
                    style={{ height: "40px" }}
                  />
                  <Typography
                    sx={{
                      marginLeft: "10px",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default SelectDeck;
